import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { LookInside } from './components/LookInside';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen w-full bg-plum text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="23w4fc33k781w">
      <MetaPixel data-id="element-1" data-mp="3iiwfuqnezm4a" />
      <main data-id="element-2" data-mp="3ijfu9xduvsdk">
        <Hero data-id="element-3" data-mp="3ihv22ef0kliv" />
        <SocialProofBar data-id="element-4" data-mp="3ii4q3wgi0ilx" />
        <PainGrid data-id="element-5" data-mp="3ml12v6jcxkhy" />
        <ProductReveal data-id="element-6" data-mp="3mkho1yp07c85" />
        <Tomes data-id="element-7" data-mp="3mjq27fl7ksv2" />
        <Bonuses data-id="element-8" data-mp="3mj6ibtbzzuee" />
        <LookInside data-id="element-9" data-mp="3rcj6618urx63" />
        <ValueStack data-id="element-10" data-mp="3rbzlwdvqcwow" />
        <Urgency data-id="element-11" data-mp="3rdkh85pvcjnt" />
        <Pricing data-id="element-12" data-mp="3rd191gq0t9mz" />
        <Guarantee data-id="element-13" data-mp="3relw6la09qat" />
        <Faq data-id="element-14" data-mp="5opiv1o0k3w" />
        <CostOfInaction data-id="element-15" data-mp="680tswt8a8y" />
        <Close data-id="element-16" data-mp="5gel8p3rovc" />
      </main>
      <Footer data-id="element-17" data-mp="7sulgbavp5r" />
      <PurchaseNotifications data-id="element-18" data-mp="2zl3cxocsjc6w" />
    </div>;
}